module.exports = __webpack_public_path__ + "img/info2.51ad43cb.png";